// ASSETS

// STYLES
import {
  AboutPageContainer,
  ScrollWrapper,
  SectionContainer,
  SectionsRow2,
} from "./AboutPageStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps, PageSection } from "./AboutPageModel";
import { ScrollCardsMenuCard } from "components/ScrollMenu/ScrollCardsMenuModel";

// REDUX

// COMPONENTS
import CardsSection from "./CardsSection/CardsSection";
import MissionSection from "./MissionSection/MissionSection";
import PersonnelSection from "./PersonnelSection/PersonnelSection";
import ProjectsSection from "./ProjectsSection/ProjectsSection";
import PartnersSection from "./PartnersSection/PartnersSection";
import ReportsSection from "./ReportsSection/ReportsSection";
import OrganizeSection from "./OrganizeSection/OrganizeSection";
import ManagementSection from "./ManagementSection/ManagementSection";
import ScrollCardsMenu from "components/ScrollMenu/ScrollCardsMenu";

const AboutPage = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const aboutSections: ScrollCardsMenuCard[] = [
    {
      id: PageSection.ORGANIZE,
      title: t("view.about.aboutDSU.navButtons.organize"),
    },
    {
      id: PageSection.ATTRIBUTIONS,
      title: t("view.about.aboutDSU.navButtons.attributions"),
    },
    {
      id: PageSection.MISSION,
      title: t("view.about.aboutDSU.navButtons.mission"),
    },
    {
      id: PageSection.PERSONNEL,
      title: t("view.about.aboutDSU.navButtons.personnel"),
    },
    {
      id: PageSection.PROJECTS,
      title: t("view.about.aboutDSU.navButtons.projects"),
    },
    {
      id: PageSection.PARTNERS,
      title: t("view.about.aboutDSU.navButtons.partners"),
    },
    {
      id: PageSection.REPORTS,
      title: t("view.about.aboutDSU.navButtons.reports"),
    },
    {
      id: PageSection.MANAGEMENT,
      title: t("view.about.aboutDSU.navButtons.management"),
    },
  ];

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <AboutPageContainer>
      <ScrollWrapper>
        <ScrollCardsMenu cards={aboutSections} />
      </ScrollWrapper>
      <SectionsRow2>
      <SectionContainer
        section={PageSection.ORGANIZE}
        id={PageSection.ORGANIZE}
      >
        <OrganizeSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.ATTRIBUTIONS}
        id={PageSection.ATTRIBUTIONS}
      >
        <CardsSection />
      </SectionContainer>
      <SectionContainer section={PageSection.MISSION} id={PageSection.MISSION}>
        <MissionSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.PERSONNEL}
        id={PageSection.PERSONNEL}
      >
        <PersonnelSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.PROJECTS}
        id={PageSection.PROJECTS}
      >
        <ProjectsSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.PARTNERS}
        id={PageSection.PARTNERS}
      >
        <PartnersSection />
      </SectionContainer>
      <SectionContainer section={PageSection.REPORTS} id={PageSection.REPORTS}>
        <ReportsSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.MANAGEMENT}
        id={PageSection.MANAGEMENT}
      >
        <ManagementSection />
      </SectionContainer>
      </SectionsRow2>
    </AboutPageContainer>
  );
};

export default AboutPage;
